import Login from "../Login/Login";
import { Route, Routes } from "react-router-dom";
import AdminLayout from "../Router/AdminLayout";
import Dashboard from "../pages/Dashboard/Dashboard";
import Contact from "../pages/Contact/Contact";
import SeoListing from "../pages/Seo/SeoListing";
import SeoCreate from "../pages/Seo/SeoCreate";
import SeoEdit from "../pages/Seo/SeoEdit";
import AuthorListing from "../pages/blogs/Author/AuthorListing";
import Category from "../pages/blogs/category/Category";
import BlogListing from "../pages/blogs/blogs/BlogListing";
import EditBlog from "../pages/blogs/blogs/EditBlog";
import AddBlog from "../pages/blogs/blogs/AddBlog";
import Project from "../pages/projectModule/projects/Project";
import AddProject from "../pages/projectModule/projects/AddProject";
import EditProject from "../pages/projectModule/projects/EditProject";
import ProjectCat from "../pages/projectModule/projectCategory/ProjectCat";
import ClientLogo from "../pages/clientLogo/ClientLogo";
import Testimonial from "../pages/testimonial/Testimonial";
import Stats from "../pages/stats/Stats";
import WeWork from "../pages/weWork/WeWork";
import Home from "../pages/home/Home";
import Location from "../pages/careerModule/location/Location";
import Department from "../pages/careerModule/department/Department";
import Job from "../pages/careerModule/jobpost/Job";
import AddJob from "../pages/careerModule/jobpost/AddJob";
import EditJob from "../pages/careerModule/jobpost/EditJob";
import LandingPage from "../pages/LandingPage/LandingPage";
import Partner from "../pages/Partner/Partner";
import JobApplications from "../pages/JobApplications/JobApplications";
import DynamicListing from "../pages/DynamicPage/DynamicListing";
import AddDynamic from "../pages/DynamicPage/AddDynamic";
import EditDynamic from "../pages/DynamicPage/EditDynamic";
import Referral from "../pages/Referral/Referral";
import FaqListing from "../pages/Faq/FaqListing";
import AddFaq from "../pages/Faq/AddFaq";
import EditFaq from "../pages/Faq/EditFaq";
import SchemaManagement from "../pages/schema-management/SchemaManagement";
import SitemapEditor from "../pages/sitemap/SitemapEditor";
import LlmsEditor from "../pages/llms/LlmsEditor";
import RobotsManagement from "../pages/robots/RobotsManagement";
import EmailManagement from "../pages/EmailManagement/EmailManagement";
import AddEmailManagement from "../pages/EmailManagement/AddEmailManagement";
import EditEmailManagement from "../pages/EmailManagement/EditEmailManagement";
import Users from "../pages/Rbac/Users";
import Roles from "../pages/Rbac/Roles";
import Permissions from "../pages/Rbac/Permissions";

export default function Router() {
  return (
    <>
      <Routes>
        <Route path={"login"} element={<Login />} />
        <Route path="/" element={<AdminLayout />}>
          <Route path="home" element={<Home />} />
          <Route index element={<Dashboard />} />

          {/* ====================Blog Module======================= */}
          <Route path="author" element={<AuthorListing />} />
          <Route path="category" element={<Category />} />

          <Route path="blog" element={<BlogListing />} />
          <Route path="add-blog" element={<AddBlog />} />
          <Route path="edit-blog/:blog_id" element={<EditBlog />} />
          {/* ====================Blog Module======================= */}


          {/* =====================Project Module==================== */}
          <Route path="project" element={<Project />} />
          <Route path="add-project" element={<AddProject />} />
          <Route path="edit-project/:project_id" element={<EditProject />} />

          <Route path="project-category" element={<ProjectCat />} />
          {/* =====================Project Module==================== */}


          {/* =====================Career Module======================= */}
          <Route path="location" element={<Location />} />
          <Route path="department" element={<Department />} />

          <Route path="job" element={<Job />} />
          <Route path="add-job" element={<AddJob />} />
          <Route path="edit-job/:job_id" element={<EditJob />} />
          {/* =====================Career Module======================= */}


          {/* =====================Home Module======================= */}
          <Route path="testimonial" element={<Testimonial />} />
          <Route path="client-logo" element={<ClientLogo />} />
          <Route path="we-work" element={<WeWork />} />
          <Route path="stats" element={<Stats />} />
          <Route path="home" element={<Home />} />
          {/* =====================Home Module======================= */}


          {/* =====================Seo Module======================= */}
          <Route path="seo" element={<SeoListing />} />
          <Route path="add-seo" element={<SeoCreate />} />
          <Route path="edit-seo/:seo_id" element={<SeoEdit />} />
          <Route path="sitemap" element={<SitemapEditor />} />
          <Route path="llms" element={<LlmsEditor />} />
          <Route path="robots" element={<RobotsManagement />} />
          <Route path="global-seo" element={<SchemaManagement />} />
          {/* =====================Seo Module======================= */}

          {/* =====================FAQ Module======================= */}
          <Route path="faq" element={<FaqListing />} />
          <Route path="add-faq" element={<AddFaq />} />
          <Route path="edit-faq/:faq_id" element={<EditFaq />} />
          {/* =====================FAQ Module======================= */}

          <Route path="contact" element={<Contact />} />
          <Route path="landing-page" element={<LandingPage />} />
          <Route path="partner-with-us" element={<Partner />} />
          <Route path="job-applications" element={<JobApplications />} />

          {/* ====================dynamic page Module======================= */}
          <Route path="dynamic" element={<DynamicListing />} />
          <Route path="add-dynamic" element={<AddDynamic />} />
          <Route path="edit-dynamic/:page_id" element={<EditDynamic />} />

          <Route path="referral" element={<Referral />} />

          {/* ====================Email Management Module======================= */}
          <Route path="email-management" element={<EmailManagement />} />
          <Route path="add-email-management" element={<AddEmailManagement />} />
          <Route path="edit-email-management/:dynamicemail_id" element={<EditEmailManagement />} />
          {/* ====================Email Management Module======================= */}

          {/* ====================User Management Module======================= */}
          <Route path="users" element={<Users />} />
          <Route path="roles" element={<Roles />} />
          <Route path="permissions" element={<Permissions />} />
          {/* ====================User Management Module======================= */}

        </Route>
      </Routes>
    </>
  )
}
